import { defineMessages } from 'react-intl';

export default defineMessages({
  ClaimNumber: {
    id: 'provision_info_claim_number',
  },
  ClaimStatus: {
    id: 'provision_info_claim_status',
  },
  CompanyCost: {
    id: 'provision_info_company_cost',
  },
  ProductRisk: {
    id: 'provision_product_risk',
  },
  Risk: {
    id: 'provision_risk',
  },
  management: {
    id: 'provision_management',
  },
  responsability: {
    id: 'provision_responsability',
  },
  provisions: {
    id: 'provision_title',
  },
  regulation: {
    id: 'provision_regulation',
  },
  field1: {
    id: 'provision_field_1',
  },
  field2: {
    id: 'provision_field_2',
  },
  field3: {
    id: 'provision_field_3',
  },
  globalProvision: {
    id: 'global_provision',
  },
  victimProvision: {
    id: 'victimProvision',
  },
  intervenantProvision: {
    id: 'intervenantProvision',
  },
  globalProvisionTitle: {
    id: 'global_provision_title',
  },
  addStakeHolder: { id: 'global_provision.add_stake_holder' },
  lawyerStakeHolder: {
    id: 'global_provision.stake_holder.lawyer',
  },
  expertStakeHolder: {
    id: 'global_provision.stake_holder.expert',
  },
  doctorStakeHolder: {
    id: 'global_provision.stake_holder.doctor',
  },
  identifierStakeHolder: {
    id: 'global_provision.stake_holder.identifier',
  },
  confirmStakeHolderDialog: {
    id: 'global_provision.stake_holder.dialog.confirm',
  },
  cancelStakeHolderDialog: {
    id: 'global_provision.stake_holder.dialog.cancel',
  },
  stakeHolderType: {
    id: 'global_provision.stake_holder.type',
  },
  stakeHolderAmount: {
    id: 'global_provision.stake_holder.amount',
  },
  stakeHolder: {
    id: 'global_provision.stake_holder',
  },
  evalTitle: {
    id: 'eval_title',
  },
  evalType: {
    id: 'eval_type',
  },
  evalAmount: {
    id: 'eval_amount',
  },
  evalDate: {
    id: 'eval_date',
  },
  updatedBy: {
    id: 'updated_by',
  },
  victimFistName: {
    id: 'victimFistName',
  },
  victimLastName: {
    id: 'victimLastName',
  },
  victimPrejudice: {
    id: 'victimPrejudice',
  },
  victimQuality: {
    id: 'victimQuality',
  },
  victProvision: {
    id: 'victProvision',
  },
  victimRegulation: {
    id: 'victimRegulation',
  },
  victimRecours: {
    id: 'victimRecours',
  },
  intervenantLastName: {
    id: 'intervenantLastName',
  },
  intervenantType: {
    id: 'intervenantType',
  },
  intervenantDesignatedField: {
    id: 'intervenantDesignatedField',
  },
  interProvision: {
    id: 'interProvision',
  },
  intervenantRegulation: {
    id: 'intervenantRegulation',
  },
  opposingPartyProvision: {
    id: 'opposingPartyProvision',
  },
  opposingPartyLastName: {
    id: 'opposingPartyLastName',
  },
  opposingPartyFirstName: {
    id: 'opposingPartyFirstName',
  },
  opposingPartyCompany: {
    id: 'opposingPartyCompany',
  },
  opposingProvision: {
    id: 'opposingProvision',
  },
  opposingPartyRegulation: {
    id: 'opposingPartyRegulation',
  },
  provisionReason: {
    id: 'provision_reason',
  },
  provisionAmount: {
    id: 'provision_amount',
  },
  provisionValidate: {
    id: 'provision_dialog_validate',
  },
  provisionCancel: {
    id: 'provision_dialog_cancel',
  },
  provisionDialogTitle: {
    id: 'provision_dialog_title',
  },
  editProvisionIntervenantSuccessMessage: {
    id: 'edit_provision_intervenant_success_message',
  },
  addStakeHolderSuccessMessage: {
    id: 'global_provision.stake_holder.dialog.toast_success',
  },
  actionHeader: {
    id: 'action.title',
  },
  addFeeNote: {
    id: 'fee_note.drawer_title',
  },
  successToastAddFeeNote: {
    id: 'toast_success.add_fee_note.title',
  },
});
